export default __webpack_public_path__ + "static/media/screenBlock25.b340676d.jpg";